import { faAngleDown } from "@jewlr/pro-regular-svg-icons/faAngleDown"
import { faAngleUp } from "@jewlr/pro-regular-svg-icons/faAngleUp"
import PropTypes from "prop-types"
import { useState } from "react"

import Expand from "components/ui/expand"
import FontAwesomeIcon from "components/ui/font-awesome-icon"

import { AccordionHeading } from "./components"

const Accordion = ({ data }) => {
  const [showDetails, setShowDetails] = useState(false)

  return (
    <div className="desktop:px-20 border-b border-b-black px-16">
      <h3>
        <AccordionHeading
          aria-controls={`warranty-accordion-content-${data.title}`}
          aria-expanded={showDetails}
          className="desktop:py-30 my-10 py-10 text-left"
          id={`warranty-accordion-heading-${data.title}`}
          onClick={() => setShowDetails(!showDetails)}
        >
          <span className="h3 mr-20 uppercase">{data.title}</span>
          <FontAwesomeIcon
            className="text-24"
            icon={showDetails ? faAngleUp : faAngleDown}
          />
        </AccordionHeading>
      </h3>
      <Expand
        aria-labelledby={`warranty-accordion-heading-${data.title}`}
        id={`warranty-accordion-content-${data.title}`}
        role="region"
        show={showDetails}
      >
        {data.why.map((data, i) =>
          data.content ? (
            <p
              className="body pb-40"
              key={`warranty-accordion-content-${data.title}-${i}`}
            >
              {data.content}
            </p>
          ) : (
            <div
              className="desktop:gap-60 desktop:grid-cols-3 tablet:pb-40 tablet:pl-40 grid grid-cols-1 gap-20 pb-20"
              key={`warranty-accordion-content-${data.title}-${i}`}
            >
              <div>
                <h4 className="h3 desktop:mb-10">What Is Covered</h4>
                <p className="body">{data.whatIsCovered}</p>
              </div>
              <div>
                <h4 className="h3 desktop:mb-10">What&apos;s Not Covered</h4>
                <p className="body">{data.whatsNotCovered}</p>
              </div>
              <div>
                <h4 className="h3 desktop:mb-10">Important Notes</h4>
                {data.importantNotes}
              </div>
            </div>
          )
        )}
      </Expand>
    </div>
  )
}

Accordion.propTypes = {
  data: PropTypes.object,
}

export default Accordion
